const Footer = () => {
  return (
    <footer className="py-4 border-t border-greyBorder">
      <div className="container">
        <div className="block xl:flex lg:flex items-center justify-center xl:justify-between lg:justify-between">
          <p className="text-sm font-source font-normal text-greyText text-center xl:text-left lg:text-left">
            © 2025 The Nick Itkin Foundation. All rights reserved.
          </p>
          <p className="text-sm font-source font-normal text-greyText text-center xl:text-left lg:text-left">
            Designed by{" "}
            <a
              target="_blank"
              href="https://www.roundtechsquare.com"
              rel="noreferrer"
              className="text-[#086AD8] font-medium"
            >
              RoundTechSquare
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
